import { LatLngExpression } from "leaflet";

export const isValidWaypoints = (waypoints: LatLngExpression[]) => {
  return waypoints.every((point) => {
    if (Array.isArray(point)) {
      return (
        point[0] !== 0 && point[1] !== 0 && !isNaN(point[0]) && !isNaN(point[1])
      );
    } else if (typeof point === "object" && "lat" in point && "lng" in point) {
      return (
        point.lat !== 0 &&
        point.lng !== 0 &&
        !isNaN(point.lat) &&
        !isNaN(point.lng)
      );
    }
    return false;
  });
};
